export enum StaffAffectationCancellationReasonEnum {
  CHANGE_OF_MIND = 'CHANGE_OF_MIND',
  PERSONAL_ISSUE_CONFIRMED = 'PERSONAL_ISSUE_CONFIRMED',
  PERSONAL_ISSUE_ALLEGED = 'PERSONAL_ISSUE_ALLEGED',
  ABSENCE_FROM_RAD = 'ABSENCE_FROM_RAD',
  NO_RESPONSE = 'NO_RESPONSE',
  CANCELLATION_BY_LEC = 'CANCELLATION_BY_LEC'
}

export const staffAffectationCancellationReasonEnumMapping: Record<
  StaffAffectationCancellationReasonEnum,
  string
> = {
  [StaffAffectationCancellationReasonEnum.CHANGE_OF_MIND]: "Changement d'avis",
  [StaffAffectationCancellationReasonEnum.PERSONAL_ISSUE_CONFIRMED]: 'Pb perso avéré',
  [StaffAffectationCancellationReasonEnum.PERSONAL_ISSUE_ALLEGED]: 'Pb perso prétendu',
  [StaffAffectationCancellationReasonEnum.ABSENCE_FROM_RAD]: 'Absence à la RAD',
  [StaffAffectationCancellationReasonEnum.NO_RESPONSE]: 'Sans retour',
  [StaffAffectationCancellationReasonEnum.CANCELLATION_BY_LEC]: 'Annulation par LEC'
}
